import { DataFilter } from '@siclop/kstone-vue'
import type { LeaveCategory } from '../enums'

export class LeaveTypeFilter extends DataFilter {
  code?: string
  label?: string
  category?: LeaveCategory

  constructor(data?: Partial<LeaveTypeFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
      this.category = data.category
    }
  }
}
